import { motion } from "framer-motion";
import { LineReveal } from "./Reveal";

export const PageHero = ({ eyebrow, lines, text, image, children }) => (
  <section data-testid="page-hero" className="relative isolate overflow-hidden pt-[76px]">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 -z-20 h-full w-full object-cover opacity-45" loading="eager" />
        <div className="absolute inset-0 -z-10 bg-gradient-to-r from-navy via-navy/85 to-navy/30" />
        <div className="absolute inset-0 -z-10 bg-gradient-to-t from-navy to-transparent" />
      </>
    )}
    <div className="absolute inset-0 -z-10 grid-bg opacity-50 [mask-image:radial-gradient(ellipse_at_top_left,black_20%,transparent_70%)]" />
    <div className="wrap py-24 lg:py-32">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }} className="eyebrow">{eyebrow}</motion.div>
      <LineReveal lines={lines} delay={0.2} className="mt-6 max-w-5xl text-4xl font-semibold leading-[1.02] sm:text-5xl lg:text-6xl xl:text-7xl" />
      {text && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.7 }} className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{text}</motion.p>
      )}
      {children && <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.85 }} className="mt-10">{children}</motion.div>}
    </div>
  </section>
);
